import React from 'react';

import Button from './Button';
import styles from './ClearButton.css';

/**
 * Generic UI  Clear button
 * @param {object} props - props
 * @returns {React.Component} the rendered button
 */
const ClearButton = props => <Button style={styles.clearButton} {...props} />;

export default ClearButton;
